import { render, staticRenderFns } from "./NotificationHeaderWidget.vue?vue&type=template&id=cdde2730&"
import script from "./NotificationHeaderWidget.vue?vue&type=script&lang=js&"
export * from "./NotificationHeaderWidget.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHeaderWidget.vue?vue&type=style&index=0&id=cdde2730&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports